const SERVICE_MAP = {
    webapp: 'https://virtualqueue.artificialsensing.com',
    vq: 'https://olonqmwdn4.execute-api.us-east-1.amazonaws.com/production',
};

export default SERVICE_MAP;
